// author: Muskan Vazirani

import React from "react";

export const EmailContext = React.createContext();